import * as $ from 'jquery';

/**
 * general class to trigger links which are given in data-attribute
 */
export class TriggerLink {

  protected linkSelector = '.js-triggerLink';
  protected links = document.querySelectorAll(this.linkSelector);
  protected scrollOffset = 40;

  constructor() {
    if (this.links) {
      // iterate through all '.js-triggerLink' and add click watcher for them
      [].forEach.call(this.links, (element) => {
        this.addClickWatcher(element);
      });
    }
  }

  /**
   * add click watcher for given element and follow data-link on click
   * @param element
   */
  protected addClickWatcher(element) {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      if (event.target) {
        window.location.href = $(event.target).closest(this.linkSelector).data('link');
      }
    });
  }
}
